import { TipoOrigemEnum } from '@/types/_'
import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

export class ConfigUsuario extends CoreBase implements IConfigUsuario {
}

export interface IConfigUsuario extends ICoreBase {
}
